package ru.villawonka.app.presentation.screens.search.viewmodel

import ru.villawonka.app.common.mvvm.UIState
import ru.villawonka.app.domain.model.NetworkFailure
import ru.villawonka.app.presentation.model.CountryUIModel
import ru.villawonka.app.presentation.model.PostUIModel
import ru.villawonka.app.presentation.screens.search.model.SearchCategoryUIModel
import ru.villawonka.app.presentation.screens.search.model.SortTypeUIModel

sealed interface SearchUIState : UIState {

    data object Loading : SearchUIState

    data class Error(val failure: NetworkFailure) : SearchUIState

    data class Data(
        val country: CountryUIModel,
        val selectedSortType: SortTypeUIModel,
        val selectedSearchCategory: SearchCategoryUIModel,
        val allSearchCategories: List<SearchCategoryUIModel>,
        val hasCustomFilters: Boolean,
    ) : SearchUIState
}

sealed class SearchResultsUIState : UIState {

    data object Loading : SearchResultsUIState()

    data object Empty : SearchResultsUIState()

    data class Error(val failure: NetworkFailure) : SearchResultsUIState()

    data class Data(
        val posts: List<PostUIModel>,
        val hasMoreData: Boolean,
    ) : SearchResultsUIState()
}

fun SearchUIState.asData(): SearchUIState.Data? =
    this as? SearchUIState.Data

fun SearchResultsUIState.asData(): SearchResultsUIState.Data? =
    this as? SearchResultsUIState.Data